import s from '@/components/layouts/WorkspaceLayout/WorkspaceLayout.module.scss';
import { Outlet } from 'react-router-dom';

interface WorkspaceContentProps {
  shouldDisplaySidebar: boolean;
}

export const WorkspaceContent = ({ shouldDisplaySidebar }: WorkspaceContentProps) => {
  return (
    <main
      className={[
        s.rootContainer,
        shouldDisplaySidebar ? s.withSidebar : s.withoutSidebar,
      ].join(' ')}
    >
      <Outlet />
    </main>
  );
};
